import React from "react";
import { Container, Button } from "react-bootstrap";

function HomeContact() {
  return (
    <section className="home-section text-center black-text" id="home-contact">
      <Container>
        <h2 className="home-subheading">
          Let's get in touch! Head to my contact page and send Dexter and I a message.
        </h2>
        <Button href="/contact" className="home-recipes-btn" size="lg">Contact</Button>
      </Container>
    </section>
  );
}

export default HomeContact;
